let view = null;

export default {
	namespace: 'template-partners',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: PartnersView } = await import(
			/* webpackChunkName: "partners-view" */ '../../templates/PartnersView'
		);
		view = new PartnersView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
